import { isValidMomentDate } from './OperatorValidators';
import { makeOperator } from './Operator';
import { RangeInputType } from '../InputTypes';
import { MomentDateWithTime } from '../DisplayTypes';
import I18n from 'I18n';
export default makeOperator({
  inputType: RangeInputType,
  displayType: MomentDateWithTime,
  name: 'NotBetweenTimePointsWithTime',
  values: [{
    name: 'value',
    isValid: isValidMomentDate
  }, {
    name: 'highValue',
    isValid: isValidMomentDate
  }]
});
export const isNotBetweenTimePointsWithTimeInstance = operator => {
  return !!operator.value && I18n.moment.isMoment(operator.value) && !!operator.highValue && I18n.moment.isMoment(operator.highValue);
};